import * as _ from 'underscore';

export class Log {
    pk: number;
    lang: string;
    pk_client: number;
    pk_campaign: number;
    created_at: string;
    delayed_to: string;
    timezone: string;
    call_provider: string;
    element: string;
    element_norm: string;
    phone_type: string;
    response: string;
    status: string;
    extra: Object;


    constructor(row: Object) {
        this.pk = row['pk'];
        this.lang = row['lang'];
        this.pk_client = row['pk_client'];
        this.pk_campaign = row['pk_campaign'];
        this.created_at = row['created_at'];
        this.delayed_to = row['delayed_to'];
        this.timezone = row['timezone'];
        this.element = row['element'];
        this.element_norm = row['element_norm'];
        this.phone_type = row['phone_type'];
        this.response = row['response'];
        this.status = row['status'];
        this.call_provider = row['service_provider_name'];
        this.extra = row['extra'];

    }

    public static getHeaders(): Array<string> {
        return [
            'pk',
            'lang',
            'pk_client',
            'pk_campaign',
            'created_at',
            'delayed_to',
            'timezone',
            'service_provider_name',
            'element',
            'element_norm',
            'phone_type',
            'response',
            'status'
        ]
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/logs/model/log.ts